import { render, staticRenderFns } from "./ContentPolls.vue?vue&type=template&id=15598744&scoped=true"
import script from "./ContentPolls.vue?vue&type=script&lang=js"
export * from "./ContentPolls.vue?vue&type=script&lang=js"
import style0 from "./ContentPolls.vue?vue&type=style&index=0&id=15598744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15598744",
  null
  
)

export default component.exports